// @flow

/* global fetch */
import * as React from 'react';
import $ from 'jquery';
import get from 'lodash/get';
import Logger from 'js-logger';
import { track, addPersistentTrackProperties } from '../lib/track';
import sendJIEvent from '../lib/kwizzad-ji';
import createTVSImageId from '../lib/cdn-image-urls';
import findIndex from 'lodash/findIndex';
import { isMatchingTargeting } from '../lib/Targeting';
import parseQueryParams from '../lib/query-params';
import includes from 'lodash/includes';

import sum from 'lodash/sum';
import flatten from 'lodash/flatten';
import sortBy from 'lodash/sortBy';
import { hadImpressionOnChallenge } from '../lib/impressionTracking';
import { defaultStyle, getStyleForCampaign } from './styles';
import replaceMacros from '../lib/replace-macros';
import OoyalaChallenge from './challenges/external-sdks/OoyalaChallenge';
import UnrulyChallenge from './challenges/external-sdks/UnrulyChallenge';
import SAPExchangeMediaChallenge from './challenges/external-sdks/SAPExchangeMediaChallenge';
import FacebookAudienceNetworkChallenge from './challenges/external-sdks/FacebookAudienceNetworkChallenge';
import SpotXChallenge from './challenges/external-sdks/SpotXChallenge';
import GoogleIMAChallenge from './challenges/external-sdks/GoogleIMAChallenge';
import IframeChallenge from './challenges/external-sdks/IframeChallenge';
import MultipleChoiceQuiz from './challenges/quiz/quiz';
import SevenPassLogin from './challenges/sevenPassLogin/seven-pass-login';
import ExternalNativeChallenge from './challenges/external-sdks/ExternalNativeChallenge';

import ContinueButton from './continue-button';
import PlaystoreButton from './playstore-button';

import type { InternalChallenge, Challenge, ChallengeStyle, QuizAnswer, WaterfallConfiguration, Statistics, StatisticsHelper } from '../lib/Challenge';
import type { Campaign } from '../lib/Campaign';


function getCurrentCampaignFromNativeApp() {
    if (window.KwizzAdJI && typeof window.KwizzAdJI.getCurrentCampaign === 'function') {
        const campaignJSON = window.KwizzAdJI.getCurrentCampaign();
        // console.log('Got current campaign information from native app.');
        const campaign = (typeof campaignJSON === 'string') ? JSON.parse(campaignJSON) : campaignJSON;
        return Promise.resolve(campaign);
    }
    if (window.kwizzadData) {
        return Promise.resolve(window.kwizzadData.campaign);
    }
    return Promise.resolve(null);
}


type Props = {
    challenge?: string,
    campaignId: string,
    trackingtoken: string,
    backendBaseURL: string,
    placement: string,
    lang: string,
    params: { [string]: string },
    extendedQueryParams: { [string]: string },
    onHashKeyKnown: ((string) => void),
    onToggleSupportButton: ((boolean) => void),
    style: ?ChallengeStyle,
};


type State = {
    challenges: InternalChallenge[],
    current: number | null,
    campaignId: ?string,
    campaign: ?Campaign,
    publisherAppDomainName: ?string,
    publisherAppName: ?string,
    punishMode: ?boolean,
    statistics : ?Statistics,
    statisticsHelper: ?StatisticsHelper,
};


class CampaignComponent extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        if (this.props.campaignId) {
            // This has been in use, but isn't actually supported by the backend.
            console.error('campaignId URL parameter is not supported.');
            return;
        }
    }

    adIsVisible = false;
    shouldTrackCompletedChallengesOnMixpanel = true;
    state = {
        challenges: [],
        current: -1,
        campaignId: null,
        campaign: null,
        publisherAppDomainName: null,
        publisherAppName: null,
        punishMode: false,
        statistics: {
            totalAnswers: 0,
            wrongAnswers: 0,
            correctAnswers: 0,
        },
        statisticsHelper: {},
    };
    hashKey: string;
    conf7pass: string;

    componentDidMount() {
        let relativeUrl = '';

        if (this.props.challenge) {
            this.shouldTrackCompletedChallengesOnMixpanel = false;
            relativeUrl = `/api/challenges/${this.props.challenge}?`;
        } else if (this.props.trackingtoken) {
            // eslint-disable-next-line max-len
            relativeUrl = `/api/trackingtoken/${this.props.trackingtoken}?requireCampaignJson=true`;
        } else {
            // eslint-disable-next-line max-len
            relativeUrl = `/api/trackingtoken/?tvsPlacement=${this.props.placement}&requireCampaignJson=true`;
        }

        const params = `&${this.encodedExtendedQueryParams()}&timestamp=${Date.now()}`;
        const absoluteUrl = this.props.backendBaseURL + relativeUrl + params;

        let campaign = null;

        getCurrentCampaignFromNativeApp()
        .then((campaignFromNativeApp) => {
            campaign = campaignFromNativeApp;
            console.log('Got campaign from native app:', campaign);
            return fetch(absoluteUrl);
        })
        .then(response => response.json())
        .then(response => {
            if (!campaign) {
                campaign = (this.props.challenge ? { } : response.campaign || response);
            }

            if (response.challenge) {
                campaign.challenges = [response.challenge];
            }

            campaign.supportButtonEnabled = response.supportButtonEnabled;

            this.setState({ campaign: ((campaign: any): Campaign) });

            this.props.onCampaignLoaded(campaign, response);

            let campaignId = null;
            if (this.props.placement || this.props.trackingtoken) {
                campaignId = response.campaignId ||
                    (response.campaign && response.campaign.id) ||
                    response.id;
                if (!campaignId) {
                    return;
                }
            }

            if (!this.props.challenge && !campaignId) {
                return;
            }

            this.setState({
                campaignId,
                publisherAppDomainName: response.publisherAppDomainName || (campaign && campaign.publisherAppDomainName),
                publisherAppName: response.publisherAppName || (campaign && campaign.publisherAppName),
            });

            const userAgent = window.navigator.userAgent;

            let osType = 'OTHER';
            if (userAgent.match('Android')) { osType = 'ANDROID'; }
            if (userAgent.match('iPhone') || userAgent.match('iPad')) { osType = 'IOS'; }

            if (campaignId) {
                addPersistentTrackProperties({
                    Source: 'Komet',
                    product: 'KWIZZAD',
                    'Operating System Type': osType,
                    'campaign id': String(campaignId),
                    clientNumber: campaign.clientNumber,
                    'campaign name': campaign.internalName,
                    'campaign business group': campaign.businessGroup,
                    'publisher app name': response.publisherAppName,
                });
            }

            this.hashKey = response.hashKey || this.props.trackingtoken;
            this.props.onHashKeyKnown(this.hashKey);

            this.trackOnKwizzadAPI();

            this.parseChallenges(campaign).then(challenges => {
                // Challenge id from the localstate, The id of the challenge the user was playing
                const challengeId = this.props.extendedQueryParams.challengeId;

                const current = this.indexForChallengeId(challenges, challengeId);

                // Get the 7pass Configuration
                this.conf7pass = response.kometConfig;

                if (current === this.state.current) {
                    console.log('Restoring The Last challenge');
                } else {
                    console.log('Showing current challenge');
                    this.setState({ current });
                }
                this.setState({ challenges });
                this.next();
            });
        })
        .catch(error => {
            const message = `Error while parsing challenges from ${absoluteUrl}: ${error} ${error.stack}`;
            console.log(message)
            sendJIEvent('fatalError', { message });
            sendJIEvent('finished');
        });
    }

    onChallengeResult(isCorrect: boolean): void {
        let statistics = this.state.statistics;
        statistics.totalAnswers = statistics.totalAnswers + 1;
        if (isCorrect) {
            statistics.correctAnswers = statistics.correctAnswers + 1;
        } else {
            statistics.wrongAnswers = statistics.wrongAnswers + 1;
        }
        this.setState({ statistics });
    }

    decreaseJokerCount() {
        let statisticsHelper = this.state.statisticsHelper;
        statisticsHelper.jokerCount = statisticsHelper.jokerCount - 1;
        this.setState({ statisticsHelper });
    }

    decreaseHintCount() {
        let statisticsHelper = this.state.statisticsHelper;
        statisticsHelper.hintCount = statisticsHelper.hintCount - 1;
        this.setState({ statisticsHelper });
    }

    // Allow customizing background colors multiple hierarchy levels:
    // - per campaign
    // - per challenge
    styleConfiguration(propertyName: string) {
        const campaignStyle = this.state.campaign ? getStyleForCampaign(this.state.campaign) : null;
        const challenge = this.currentChallenge();
        return (challenge && challenge.style && get(challenge.style, propertyName))
            || (campaignStyle && get(campaignStyle, propertyName))
            || (get(defaultStyle, propertyName))
    }


    countChallenges(challenges: InternalChallenge[]) {
        return sum(challenges.map((challenge) => {
            const isCounted =
                !challenge.X_DISMISS_WITHOUT_OPENING && // do not count web challenges that are not actually opened
                (!challenge.isWaterfall || challenge.isFirstOfWaterfall); // only count the first challenge of an expanded waterfall challenge chain
            return isCounted ? 1 : 0;
        }));
    }

    isChallengeCountedInPagination(challenge: InternalChallenge) {
        return !challenge.X_DISMISS_WITHOUT_OPENING && // do not count web challenges that are not actually opened
            !(challenge.originalChallenge && challenge.originalChallenge.isRTAChallenge) &&
            !challenge.isWaterfall;
    }

    displayedPaginationIndex() {
        return sum(this.state.challenges.map((challenge, index) => {
            const isCounted =
                index <= (this.state.current || 0) &&
                this.isChallengeCountedInPagination(challenge);
            return isCounted ? 1 : 0;
        }));
    }

    displayedNumberOfChallenges() {
        return sum(this.state.challenges.map((challenge) => {
            const isCounted = this.isChallengeCountedInPagination(challenge);
            return isCounted ? 1 : 0;
        }));
    }

    encodedExtendedQueryParams() {
        const encode = encodeURIComponent;
        const params = this.props.extendedQueryParams;
        return Object.keys(params)
            .map(key => `${encode(key)}=${encode(params[key])}`)
            .join('&');
    }

    trackOnKwizzadAPI() {
        if (!this.hashKey) return;
        const path = `${this.props.backendBaseURL}/api/trackingtoken/`;
        const query = `hashKey=${this.hashKey}&${this.encodedExtendedQueryParams()}`;
        $.ajax({
            url: `${path}?${query}`,
            method: 'PUT',
        })
        .done(() => Logger.debug('Tracked on Kwizzad API'))
        .fail(err => Logger.debug('Could not track on Kwizzad API:', err));
    }

    indexForChallengeId(challenges: InternalChallenge[], challengeId: string) {
        if (challengeId) {
            const challenge = challenges.find((c) => {
                return c.id === challengeId;
            });
            if (challenge) return challenge.num - 1;
        }
        return -1;
    }

    parseChallenges(campaign: Campaign): Promise<InternalChallenge[]> {
        const isSupported = (parsedChallenge) => {
            if (typeof parsedChallenge.componentClass.isSupportedOnCurrentPlatform === 'function') {
                return parsedChallenge.componentClass.isSupportedOnCurrentPlatform();
            }
            return true;
        };

        const parse = challenge => this.parseChallenge(challenge, campaign);
        const userData = this.props.extendedQueryParams;

        return Promise.all(campaign.challenges.map(parse))
            .then(challenges => {
                const resultsBeforeFiltering = flatten(flatten(flatten(challenges)))
                const results = resultsBeforeFiltering
                    .filter(Boolean)
                    .filter(isSupported)
                    .filter(challenge => challenge.enabled !== false)
                    .filter(challenge => isMatchingTargeting(userData, challenge.targeting))
                    .map((challenge, index) => Object.assign(challenge, { num: index }));
                return results;
            });
    }


    getWaterfallConfigurationForChallenge(challenge: Challenge): Promise<?WaterfallConfiguration> {
        if (!challenge || !challenge.properties) return Promise.resolve(null);

        if (challenge.properties.X_WATERFALL_CONFIG) {
            return Promise.resolve(challenge.properties.X_WATERFALL_CONFIG);
        }
        if (challenge.properties.X_WATERFALL_URL) {
            return fetch(challenge.properties.X_WATERFALL_URL).then(r => r.json());
        }
        return Promise.resolve(null);
    }


    expandWaterfallChallenges(originalChallenge: Challenge, config: WaterfallConfiguration): InternalChallenge[] {
        if (!config) return [];
        const sortedConfig = sortBy(config.filter(Boolean), c => (c || {}).rCPM || 0).reverse();
        const results = sortedConfig.map((configEntry, index) => {
            const isFirstOfWaterfall = index === 0;
            const result = Object.assign(
                {},
                originalChallenge,
                {
                    sdkType: configEntry.provider
                },
                {
                    properties: Object.assign(
                        {},
                        originalChallenge.properties,
                        Object.assign({}, configEntry),
                        {
                            isWaterfall: true,
                            waterfallId: `${originalChallenge.id}-${index}`,
                            isLastOfWaterfall: index === (sortedConfig.length - 1),
                            isFirstOfWaterfall,
                        }
                    ),
                },
            );
            return result;
        });

        return results;
    }


    parseChallenge(challenge: Challenge, campaign: Campaign, stopRecursion: boolean = false): Promise<InternalChallenge[]> {
        const challengeAsString = JSON.stringify(challenge);
        const isPunishMode = (this.props.params.queryParams.punishMode === 'true');
        if(isPunishMode) {
            console.log('Punish mode is on!!');
            this.setState({ punishMode: true });
        }

        console.log('Parsing challenge', challenge.id);

        if (isPunishMode && this.isChallengeQuiz(challenge)){
            challenge.rtaAfterChallenge = true;
        }

        if (challenge.challengeType === 'list') {
            const promises = challenge.challenges.map(c => this.parseChallenge(c, campaign));
            return Promise.all(promises);
        }

        if (!stopRecursion && (challenge.rtaBeforeChallenge || challenge.rtaAfterChallenge)) {
            const rtaChallenge = { challengeType: 'native', properties: {}, isRTAChallenge: true };
            const challenges = [
                challenge.rtaBeforeChallenge ? rtaChallenge : null,
                challenge,
                challenge.rtaAfterChallenge ? rtaChallenge : null,
            ].filter(Boolean);

            return Promise.all(challenges.map(c => this.parseChallenge(c, campaign, true)));
        }

        if (window.KwizzAdJI) {
            console.log('KwizzAdJI detected');
            if (typeof window.KwizzAdJI.isNativeChallenge === 'function') {
                const result = window.KwizzAdJI.isNativeChallenge(challengeAsString);
                console.log('KwizzAdJI.isNativeChallenge detected. It returns:', result);
                if (result) {
                    console.log('Native app supports this challenge');
                    return [{
                        type: challenge.challengeType,
                        id: String(challenge.id),
                        originalChallenge: challenge,
                        componentClass: ExternalNativeChallenge,
                        isNativeChallenge: true,
                    }];
                } else {
                    console.log('Native app has no native support for this challenge');
                }
            }
        }

        if (challenge.challengeType === 'native' && challenge.sdkType === 'waterfall') {
            return this.getWaterfallConfigurationForChallenge(challenge)
                .then(configuration => this.expandWaterfallChallenges(challenge, configuration))
                .then(challenges => challenges.map(c => this.parseChallenge(c, campaign)));
        }

        const properties = challenge.properties;
        if (!properties) return null;

        const m = Object.assign({}, properties, {
            type: challenge.challengeType,
            id: String(challenge.id),
            originalChallenge: challenge,
        });

        if (challenge.challengeType === 'letterPoolQuiz') {
            m.originalLetterpoolChallenge = challenge;
        }

        if (challenge.challengeType === 'web') {
            if (typeof challenge.url === 'string') {
                m.url = challenge.url.replace(/^xhttp:/, 'http:');
            }
            m.goalUrl = challenge.goalUrl;
            if (challenge.goalUrl) {
                sendJIEvent('goalurl', challenge.goalUrl);
            }
            m.callToActionUrlWithRedirect = this.callToActionUrlWithRedirect(String(challenge.id));
            const isPlayStoreLink = !!campaign.playstoreLink;
            m.componentClass = isPlayStoreLink ? PlaystoreButton : ContinueButton;
            return [m];
        }

        // Legacy handling for Ooyala
        if (challenge.challengeType === 'video' && challenge.properties.OY_CONTENTID) {
            Object.assign(challenge, {
                challengeType: 'native',
                provider: 'ooyala',
                placement: challenge.OY_CONTENTID,
            });
        }

        if (challenge.challengeType === 'native') {
            const componentClasses = {
                unruly: UnrulyChallenge,
                facebook: FacebookAudienceNetworkChallenge,
                spotx: SpotXChallenge,
                sap_exchange_media: SAPExchangeMediaChallenge,
                SevenPassLogin: SevenPassLogin,
                ooyala: OoyalaChallenge,
                GoogleIMA: GoogleIMAChallenge,
                Iframe: IframeChallenge,
            };
            const ComponentClass = componentClasses[challenge.sdkType || challenge.provider] || ExternalNativeChallenge;
            m.componentClass = ComponentClass;

            // If the component is wrapped inside a styled() container, we need to use the target
            // property of the wrapped component to get the wrapped component's original constructor.
            const disablesSupportButtonFn = ComponentClass.disablesSupportButton ||
                (ComponentClass.target && ComponentClass.target.disablesSupportButton);

                if (disablesSupportButtonFn) {
                m.disablesSupportButton = disablesSupportButtonFn();
            }
            return [m];
        }

        if (includes(['letterPoolQuiz', 'multipleChoiceQuiz', 'multipleChoicePoll'], challenge.challengeType)) {
            this.state.punishMode ? m.punishMode=true : m.punishMode=false;

            const queryParams = parseQueryParams(window.location.search);

            if(challenge.challengeType === 'letterPoolQuiz'){
                let statisticsHelper = this.state.statisticsHelper;
                if(isNaN(queryParams.hint_count) === false){
                    statisticsHelper.hintCount = parseInt(queryParams.hint_count, 10)
                };
                if(isNaN(queryParams.joker_count) === false){
                    statisticsHelper.jokerCount = parseInt(queryParams.joker_count, 10)
                };
                this.setState({ statisticsHelper });
                m.statisticsHelper = statisticsHelper;
            }

            m.componentClass = MultipleChoiceQuiz;
            m.question = {
                text: replaceMacros(queryParams, challenge.question),
                imageUrl: createTVSImageId(challenge.questionImage || challenge.imageName, 'campaigns'),
            };
            m.successImageUrl = createTVSImageId(challenge.successImageName, 'campaigns');
            m.failImageUrl = createTVSImageId(challenge.failImageName, 'campaigns');
            m.answers = [];
            m.successMessage = replaceMacros(queryParams, challenge.successMessage);

            for (let i = 1; i <= 4; i++) {
                const answer: QuizAnswer = {
                    id: i,
                    text: replaceMacros(queryParams, challenge[`answer${i}`]),
                    solution: replaceMacros(queryParams, challenge[`answer${i}Solution`]),
                    correct: challenge.challengeType === 'multipleChoicePoll'
                      || challenge.correctAnswer === i,
                    poll: challenge.challengeType === 'multipleChoicePoll',
                };
                if (answer.text != null && answer.text.length > 0) {
                    m.answers.push(answer);
                }
            }

            return [m];
        }

        return [];
    }

    callToActionUrlWithRedirect(challengeId: string): string {
        const baseUrl = this.props.backendBaseURL;
        const url = `${baseUrl}/web/goto/redirect?hashKey=${this.hashKey}&challengeId=${challengeId}`
        return url;
    }

    hasMoreChallenges(): boolean {
        return this.state.challenges &&
          this.state.challenges.length > (this.state.current + 1);
    }

    nextChallenge(): ?InternalChallenge {
        return this.challengeWithIndex(this.state.current + 1);
    }

    currentChallenge(): ?InternalChallenge {
        return this.challengeWithIndex(this.state.current);
    }

    challengeWithIndex(index: number): ?InternalChallenge {
        if (!this.state.challenges) return null;
        if (index === null) return null;
        if (index < 0 || index >= this.state.challenges.length) return null;
        return this.state.challenges[index];
    }

    nextChallengeUrl(): ?string {
        // To remove the referrer header when opening the goal link, we need to
        // let the user click on a link with `rel="noreferrer"` set. We have
        // tried several other approaches but due to lack of standardization
        // this can't be achieved otherwise across browsers currently.

        const challenge = this.nextChallenge();
        if (challenge && challenge.type === 'web') {
            return this.callToActionUrlWithRedirect(challenge.id);
        }
        return null;
    }

    trackChallengeCompletionIfNecessary(index): void {
        const currentChallenge = this.challengeWithIndex(index);
        const nextChallenge = this.challengeWithIndex(index + 1);
        const currentChallengeIsWaterfall = currentChallenge && currentChallenge.isWaterfall;
        const nextChallengeIsWaterfall = nextChallenge && nextChallenge.isWaterfall;
        const isContinuedWaterfall = currentChallengeIsWaterfall && nextChallengeIsWaterfall;

        if (this.state.current >= 0 && !isContinuedWaterfall) {
            console.log('sending challengeCompleted')
            sendJIEvent('challengeCompleted', this.state.current);
            this.trackChallengeCompleted();
        }
    }


    next(isCorrect?: boolean): void {
        if (typeof isCorrect === 'boolean' && isCorrect && this.state.punishMode) {
            console.log('Skipping ad...');
            let position = this.state.current + 1;
            while (this.challengeWithIndex(position) && this.challengeWithIndex(position).originalChallenge.isRTAChallenge) {
                position++;
            }
            if (position === this.state.challenges.length) {
                this.finish();
            } else {
                this.skipToChallengeIndex(position);
            }
            return;
        }
        this.skipToChallengeIndex(this.state.current + 1);
    }

    skipToLastChallengeIfThisIsTheLastWaterfallChallenge(): void {
        const currentChallenge = this.currentChallenge();
        const nextChallenge = this.nextChallenge();
        const currentChallengeIsWaterfall = currentChallenge && currentChallenge.isWaterfall;
        const hasUpcomingWaterfallChallenge = nextChallenge && nextChallenge.isWaterfall;
        const isOnLastWaterfallChallenge = currentChallengeIsWaterfall && !hasUpcomingWaterfallChallenge;

        if (isOnLastWaterfallChallenge) {
            this.skipToLastChallenge();
        } else {
            this.next();
        }
    }

    skipToLastChallenge(): void {
        this.skipToChallengeIndex(this.state.challenges.length - 1);
    }

    // Skips to the next challenge that is not part of a RTA waterfall configuration.
    skipToNextNonWaterfallChallenge(): void {
        const currentIndex = this.state.current;
        const isNoWaterfall = challenge => !challenge.isWaterfall;
        const nextIndex = findIndex(this.state.challenges, isNoWaterfall, currentIndex + 1);
        if (nextIndex === -1) {
            this.next();
            return;
        }
        this.skipToChallengeIndex(nextIndex);
    }

    hasUpcomingWaterfallChallengesAfterIndex(index: number): boolean {
        return findIndex(this.state.challenges, (c => c.isWaterfall), index + 1) !== -1;
    }

    hasWaterfallChallenges() {
        return findIndex(this.state.challenges, (c => c.isWaterfall)) !== -1;
    }

    triggerConversionIfNecessary(challengeIndex: number): Promise<any> {
        const challenge = this.state.challenges[challengeIndex];

        const isTrackingNecessary =
            challenge &&
            this.hasWaterfallChallenges() &&
            !this.hasUpcomingWaterfallChallengesAfterIndex(challengeIndex);

        if (!isTrackingNecessary) {
            return Promise.resolve();
        }

        // If the next challenge has the X_REPORT_IMPRESSIONS flag set, report collected
        // impressions to the backend.
        return new Promise((resolve, reject) => {
            const trackingToken = this.props.hashKey;
            const partnerId = 'KwizzadRTA';
            const secret = 'YYDAkksd9cdllPm3';
            const challenges = flatten(this.state.challenges.map(challenge => challenge.challenges || challenge));
            const cpms: number[] = challenges.map(challenge => hadImpressionOnChallenge(challenge) ? (challenge.rCPM || 0) : 0);
            const commission = 0.001 * sum(cpms);
            const baseUrl = this.props.backendBaseURL;
            const url = `${baseUrl}/api/callback/conversion?partner=${partnerId}&aff_sub=${trackingToken}&secret=${secret}&commission=${commission}`;
            if (cpms.length === 0 || commission === 0) {
                resolve();
                return;
            }
            // console.log('Reporting impressions', url);
            return fetch(url).then(resolve, resolve);
        }).catch(console.log);
    }

    skipToChallengeIndex(index: number): void {
        this.trackChallengeCompletionIfNecessary(index);
        this.triggerConversionIfNecessary(index).then(() => {
            if (!this.hasMoreChallenges()) {
                this.finish();
                return;
            }
            this.setState({ current: null });
            this.setState({ current: index });
            this.updateSupportButton();
        });
    }

    finish() {
        console.log('Sending finished event...');
        if (this.state.punishMode) {
            const allStatistics = { ...this.state.statistics, ...this.state.statisticsHelper };
            console.log(allStatistics);
            sendJIEvent('finished', JSON.stringify(allStatistics));
        } else {
            console.log(this.state.statisticsHelper);
            sendJIEvent('finished', JSON.stringify(this.state.statisticsHelper));
        }
        this.setState({ current: null });
    }

    updateSupportButton(): void {
        const currentChallenge = this.currentChallenge();
        if (!currentChallenge) return;
        this.props.onToggleSupportButton(!currentChallenge.disablesSupportButton && this.state.campaign.supportButtonEnabled);
    }

    percentFinished(): number {
        return Math.round(
            (this.state.current * 100.0) / this.state.challenges.length
        );
    }

    trackChallengeCompleted(callback: (() => void) = () => {}): void {
        if (!this.shouldTrackCompletedChallengesOnMixpanel)
            return;
        track(`ChallengeCompleted`, this.challengeTrackProperties(), callback);
    }

    challengeTrackProperties() {
        const challenge = this.currentChallenge();
        if (!challenge) return {};
        return {
            percent: this.percentFinished(),
            challengeIndex: challenge.num,
            challengeCount: this.countChallenges(this.state.challenges),
            type: challenge.type,
            sdkType: challenge.sdkType,
        };
    }

    isChallengeQuiz(challenge: Challenge){
        if (includes(['letterPoolQuiz', 'multipleChoiceQuiz', 'multipleChoicePoll'], challenge.challengeType)) {
            return true;
        }
        return false;
    }

    render(): JSX.Element {
        if (this.state.current === null) return (<span />);
        if (this.state.current >= 0 && this.state.challenges.length > 0) {
            const challenge = this.currentChallenge();
            if (!challenge) {
                const message = `No challenge found at index ${this.state.current}`;
                console.log(message);
                sendJIEvent('fatalError', { message });
                sendJIEvent('finished');
                return (<span />);
            }

            if (challenge && challenge.componentClass) {
                return (
                    <challenge.componentClass
                      style={this.props.style}
                      campaign={this.state.campaign}
                      publisherAppDomainName={this.state.publisherAppDomainName}
                      params={this.props.params}
                      challenge={challenge}
                      trackingtoken={this.hashKey}
                      conf7pass={this.conf7pass}
                      challengeTrackProperties={this.challengeTrackProperties()}
                      paginationCount={this.displayedNumberOfChallenges()}
                      paginationIndex={this.displayedPaginationIndex()}
                      next={(data) => this.next(data)}
                      skipToLastChallengeIfThisIsTheLastWaterfallChallenge={() => this.skipToLastChallengeIfThisIsTheLastWaterfallChallenge()}
                      skipToNextNonWaterfallChallenge={() => this.skipToNextNonWaterfallChallenge()}
                      nextChallenge={() => this.nextChallenge()}
                      nextChallengeUrl={() => this.nextChallengeUrl()}
                      challengeCount={this.countChallenges(this.state.challenges)}
                      lang={this.props.lang}
                      code={this.props.extendedQueryParams.code}
                      target={this.props.backendBaseURL}
                      styleConfiguration={(key) => this.styleConfiguration(key)}
                      onChallengeResult={(result: boolean) => this.onChallengeResult(result)}
                      decreaseJokerCount = {() => this.decreaseJokerCount()}
                      decreaseHintCount = {() => this.decreaseHintCount()}
                    />
                );
            }
            return (<span />);
        }

        return (<span />);
    }
}

export default CampaignComponent;



// WEBPACK FOOTER //
// ./src/campaign/campaign.jsx